import { TopToolbar, ListButton } from 'react-admin';

export const TagGroupActions = ({ basePath }) => (
    <TopToolbar>
        <ListButton basePath={basePath} />
    </TopToolbar>
);